<template>
  <a-spin :spinning="spinning">
  <div class="" :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0" :class="type === 'dark' ? 'bg-transparent': ''">

      <div class="row align-items-center">
        <div class="col-md-3">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            {{_.startCase(currentProfile)}}
          </h3>
        </div>

        <div v-if="selectedRowKeys != null" class="col-md-9 text-right">
          <!-- {{selectedRows}} -->
          <br/>
          <!-- <button v-if="selectedRows[0].sign_off_date_formatted == ''" :disabled="selectedRows[selectedIndex].declare_date_formatted != ''" type="button" class="btn btn-sm btn-primary" @click.prevent="showDrawer('sign_off')"> Force Signoff</button>  -->
           <button v-if="selectedRows[0].sign_off_date_formatted == ''" type="button" class="btn btn-sm btn-primary" @click.prevent="showDrawer('sign_off')"> Force Signoff</button>
          <button v-if="selectedRows[0].declare_date_formatted == ''"  :disabled="selectedRows[selectedIndex].sign_off_date_formatted == ''" type="button" class="btn btn-sm btn-danger" @click.prevent="showDrawer('declare')"> Force Declare</button>
          <button v-if="selectedRows[0].declare_date_formatted != '' && selectedRows[selectedIndex].is_declared != 1"  type="button" class="btn btn-sm btn-warning" @click.prevent="showDrawer('audit')"> For Declaration (Audit)</button>
          <!-- <button v-if="selectedRows[0].declare_date_formatted != '' && selectedRows[selectedIndex].is_declared == 1"  type="button" class="btn btn-sm btn-warning" @click.prevent="showDrawer('show_breakdown')"> Show Breakdown</button>  -->
          <button v-if="selectedRows[0].declare_date_formatted != '' && selectedRows[selectedIndex].is_declared == 1"  type="button" class="btn btn-sm btn-success" @click.prevent="showDrawer('validate')"> Show Summary </button>
          <button v-if="(declaredCount == posSessions.length) && (posSessions.length > 0) && filterStatus == 0" type="button" class="btn btn-sm btn-success" @click.prevent="startEndOfDay"> Start End of Day </button>
        </div>
        <div v-else class="col-md-9 text-right">
          <button v-if="(declaredCount == posSessions.length) && (posSessions.length > 0) && filterStatus == 0" type="button" class="btn btn-sm btn-success" @click.prevent="startEndOfDay"> Start End of Day </button>
        </div>


      </div>

      <div v-if="selectedRowKeys != null">
        <a-modal
            title="Declaration Summary"
            :visible="modalVisible"
            @cancel="modalVisible = false"
          >

            <!-- @ok="audit"
             -->

              <!-- <b>Actual Cash Amount:</b>   &nbsp;&nbsp;&nbsp;&nbsp; PHP {{actualCashAmount}} <br>
              <b>Expected Cash Amount:</b> PHP {{selectedRows[selectedIndex].expected_cash_amount}} <br> -->
              <template slot="footer">
                  <a-button key="back" @click="modalVisible = false">
                    Cancel
                  </a-button>
                  <a-button key="submit" type="primary"  @click="audit">
                    Ok
                  </a-button>
                  <a-button key="print" type="primary" @click="isHalfOfALetter ? printEodHalfOfLetter() : printEod()">
                    Print
                  </a-button>
              </template>

              <template v-if="declarationMode == 1">
                <div class="row">
                  <a-statistic class="col-md-6 demo-class" title="Actual Cash Amount" :value="parseFloat(auditBreakdownTotal).toFixed(2)" />
                  <a-statistic v-if="this.excludeInitialCashFloat == true  || selectedRows[selectedIndex].float == null" class="col-md-6 demo-class" title="Expected Cash Amount" :value="selectedRows[selectedIndex].expected_cash_amount" />
                  <a-statistic v-else class="col-md-6 demo-class" title="Expected Cash Amount" :value="(parseFloat(selectedRows[selectedIndex].expected_cash_amount) + parseFloat(selectedRows[selectedIndex].float))" />
                </div>
                <hr class="my-2">
                <div v-if="this.excludeInitialCashFloat == true  || selectedRows[selectedIndex].float == null">
                  <div v-if="parseFloat(auditBreakdownTotal).toFixed(2)- parseFloat(selectedRows[selectedIndex].expected_cash_amount) > 0">
                    <h2><span class="fa fa-arrow-up text-green"/> Over: {{ (parseFloat(auditBreakdownTotal).toFixed(2) - parseFloat(selectedRows[selectedIndex].expected_cash_amount)).toFixed(2) }} </h2>
                  </div>
                  <div v-if="parseFloat(auditBreakdownTotal).toFixed(2) - parseFloat(selectedRows[selectedIndex].expected_cash_amount) < 0">
                    <h2><span class="fa fa-arrow-down text-red"/> Short: {{ (parseFloat(auditBreakdownTotal).toFixed(2) - parseFloat(selectedRows[selectedIndex].expected_cash_amount)).toFixed(2) }} </h2>
                  </div>
                </div>
                <div v-else>
                  <div v-if="parseFloat(auditBreakdownTotal).toFixed(2)- parseFloat(selectedRows[selectedIndex].expected_cash_amount) > 0">
                    <h2><span class="fa fa-arrow-up text-green"/> Over: {{ (parseFloat(auditBreakdownTotal).toFixed(2) - (parseFloat(selectedRows[selectedIndex].expected_cash_amount) + parseFloat(selectedRows[selectedIndex].float)).toFixed(2)) }} </h2>
                  </div>
                  <div v-if="parseFloat(auditBreakdownTotal).toFixed(2) - parseFloat(selectedRows[selectedIndex].expected_cash_amount) < 0">
                    <h2><span class="fa fa-arrow-down text-red"/> Short: {{ (parseFloat(auditBreakdownTotal).toFixed(2) - (parseFloat(selectedRows[selectedIndex].expected_cash_amount) + parseFloat(selectedRows[selectedIndex].float)).toFixed(2)) }} </h2>
                  </div>
                </div>
                <a-checkbox v-model="isHalfOfALetter">Print half of A letter</a-checkbox>
              </template>
              <template v-if="declarationMode == 2">
                <div class="row">
                  <a-statistic class="col-md-6 demo-class" title="Actual Cash Amount" :value="parseFloat(actualCashAmount).toFixed(2)" />
                  <a-statistic v-if="this.excludeInitialCashFloat == true  || selectedRows[selectedIndex].float == null" class="col-md-6 demo-class" title="Expected Cash Amount" :value="selectedRows[selectedIndex].expected_cash_amount" />
                  <a-statistic v-else class="col-md-6 demo-class" title="Expected Cash Amount" :value="(parseFloat(selectedRows[selectedIndex].expected_cash_amount) + parseFloat(selectedRows[selectedIndex].float))" />
                </div>
                <hr class="my-2">
                <div v-if="this.excludeInitialCashFloat == true || selectedRows[selectedIndex].float == null">
                  <div v-if="parseFloat(actualCashAmount).toFixed(2)- parseFloat(selectedRows[selectedIndex].expected_cash_amount) > 0">
                    <h2><span class="fa fa-arrow-up text-green"/> Over: {{ (parseFloat(actualCashAmount).toFixed(2) - parseFloat(selectedRows[selectedIndex].expected_cash_amount)).toFixed(2) }} </h2>
                  </div>
                  <div v-if="parseFloat(actualCashAmount).toFixed(2) - parseFloat(selectedRows[selectedIndex].expected_cash_amount) < 0">
                    <h2><span class="fa fa-arrow-down text-red"/> Short: {{ (parseFloat(actualCashAmount).toFixed(2) - parseFloat(selectedRows[selectedIndex].expected_cash_amount)).toFixed(2) }} </h2>
                  </div>
                </div>
                <div v-else>
                  <div v-if="parseFloat(actualCashAmount).toFixed(2)- parseFloat(selectedRows[selectedIndex].expected_cash_amount) > 0">
                    <h2><span class="fa fa-arrow-up text-green"/> Over: {{ (parseFloat(actualCashAmount).toFixed(2) - (parseFloat(selectedRows[selectedIndex].expected_cash_amount) + parseFloat(selectedRows[selectedIndex].float)).toFixed(2)) }} </h2>
                  </div>
                  <div v-if="parseFloat(actualCashAmount).toFixed(2) - parseFloat(selectedRows[selectedIndex].expected_cash_amount) < 0">
                    <h2><span class="fa fa-arrow-down text-red"/> Short: {{ (parseFloat(actualCashAmount).toFixed(2) - (parseFloat(selectedRows[selectedIndex].expected_cash_amount) + parseFloat(selectedRows[selectedIndex].float)).toFixed(2)) }} </h2>
                  </div>
                </div>
              </template>
        </a-modal>

        <a-modal
            title="Override Declaration"
            :visible="modalVisible2"
            @ok="overrideDeclaration"
            @cancel="modalVisible2 = false"
          >


            <div v-if="declarationMode == 2">

              <table class="table table-sm" style="overflow: hidden; table-layout: fixed; word-wrap: break-word;">
                <tr>
                  <td>Original Declaration Amount</td>
                  <td align="right"> PHP {{selectedRows[0].actual_cash_amount}} </td>
                </tr>
                <tr>
                  <td>Expected Cash Amount</td>
                  <td align="right"> PHP {{selectedRows[0].expected_cash_amount}} </td>
                </tr>
                <tr>
                  <td>New Discrepancy</td>
                  <td align="right"> PHP {{ (parseFloat(selectedRows[0].expected_cash_amount) - (overrideAmount)).toFixed(2) }} </td>
                </tr>
                <tr>
                  <td>Override Declaration Amount</td>
                  <td align="right"> <h2>PHP {{parseFloat(overrideAmount).toFixed(2)}}</h2> </td>
                </tr>
              </table>

            </div>


            <div v-if="declarationMode == 1">

              <table class="table table-sm" style="overflow: hidden; table-layout: fixed; word-wrap: break-word;">
                <tr>
                  <td>Original Declaration Amount</td>
                  <td align="right"> PHP {{selectedRows[0].actual_cash_amount}} </td>
                </tr>
                <tr>
                  <td>Expected Cash Amount</td>
                  <td align="right"> PHP {{selectedRows[0].expected_cash_amount}} </td>
                </tr>
                <tr>
                  <td>New Discrepancy</td>
                  <td align="right"> PHP {{ (parseFloat(selectedRows[0].expected_cash_amount) - (newDeclarationAmountCash + newDeclarationAmountNonCash)).toFixed(2) }} </td>
                </tr>
                <tr>
                  <td>Override Declaration Amount</td>
                  <td align="right"> <h2>PHP {{(newDeclarationAmountCash + newDeclarationAmountNonCash).toFixed(2)}}</h2> </td>
                </tr>
              </table>

              <small>Declaration Override Breakdown: </small>

              <!-- {{breakdown}} -->
              <table v-if=' !_.isEmpty(moneyBreadown)' class="table table-sm" style="overflow: hidden; table-layout: fixed; word-wrap: break-word;">
                <tbody>
                  <tr>
                    <th>Denomination</th>
                    <td align="right">Qty</td>
                    <td align="right">Amount</td>
                  </tr>
                  <tr v-for="(denomination, index) in moneyBreadown" :key="index">
                   <template v-if="! _.isEmpty(breakdown[denomination]) && !_.isNaN(parseFloat(denomination))">
                     <td>{{denomination}}</td>
                     <td align="right">{{parseInt(breakdown[denomination])}}</td>
                     <td align="right"> {{parseFloat(denomination) * parseInt(breakdown[denomination])}}</td>
                   </template>
                  </tr>
                   <tr>
                     <td colspan="2"> <h3>TOTAL: </h3></td>
                     <td align="right"> <h3> PHP {{ computeBreakdownCash().toFixed(2) }} </h3> </td>
                   </tr>
                </tbody>
              </table>

              <table v-if=' !_.isEmpty(breakdown)' class="table table-sm" style="overflow: hidden; table-layout: fixed; word-wrap: break-word;">
                <tbody>
                  <tr>
                    <th>Non_Cash</th>
                    <td align="right">Amount</td>
                  </tr>
                  <tr v-for="(item, key, index) in breakdown" :key="index">
                    <template v-if= "_.isNaN(parseFloat(key))">
                     <td>{{key}}</td>
                     <td align="right">{{ parseFloat(item) }}</td>
                    </template>
                  </tr>
                  <tr>
                    <td colspan="2"> <h3>TOTAL: </h3></td>
                    <td align="right"> <h3> PHP {{ computeBreakdownNonCash().toFixed(2) }} </h3> </td>
                  </tr>
                </tbody>
              </table>

            </div>

        </a-modal>
      </div>

      <a-drawer v-if="showEOD" title="" :width="900" placement="right" @close="closeEod" :visible="showEOD">
        <h3>Barter POS Monitoring</h3>
        <small>This tool ise used to view branch POS transactions before submissions on a per day basis over a period of time:</small>

        <br/><br/>
        <div class="row">
          <div class="col-md-6">
            Site: <b>{{ siteName }} </b> <br/>
            Date: <b>{{ filterDate.format('YYYY-MM-DD') }} </b>
          </div>
          <div class="col-md-6 float-right">
            <small>Legend: </small> <br/>
            <a-badge status="success"/> No Missing <br/>
            <a-badge status="warning"/> No Transaction <br/>
            <a-badge  status="error"/> With Missing <br/>
          </div>
        </div>

        <hr>

        <a-table :columns="eodColumns" :dataSource="eodDetails" bordered style="height: 100vh;" :key="tableKey">
          <span slot="missing" slot-scope="record, text">
            <a-badge v-if="text.missing == 0 && text.trans_count > 0" status="success" />
            <a-badge v-if="text.missing == 0 && text.trans_count == 0" status="warning" />
            <a-badge v-if="text.missing > 0 && text.trans_count > 0" status="error" />
            {{text.missing}}
          </span>
        </a-table>

        <br/><br/>
          <div class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
            <button class="btn btn-primary" @click.prevent="onCloseEod">Proceed with EOD</button>
          </div>

      </a-drawer>


      <a-modal
            title="EOD Confirmation"
            :visible="eodModalVisible"
            :zIndex="2000"
            @cancel="eodModalVisible = false"
          >
          {{this.eodMessage}}
              <template slot="footer">
                <div v-if="proceedEod == true">
                  <a-button @click="eodModalVisible = false">
                    Cancel
                  </a-button>
                  <a-button type="primary"  @click="finalizeEod">
                    Continue
                  </a-button>
                </div>
                <div v-else>
                  <a-button @click="eodModalVisible = false">
                    Ok
                  </a-button>
                </div>
            </template>
        </a-modal>

        <a-modal
            title="EOD Confirmation"
            :visible="eodModalVisible2"
            :zIndex="2000"
            @cancel="eodModalVisible2 = false"
          >
              WARNING: Doing End of Day will disable POS from logging in on the current business date of {{filterDate.format('YYYY-MM-DD')}}. Have all the transactions and collections been accounted for and you want to continue the process?
              <template slot="footer">
                <div v-if="proceedEod == true">
                  <a-button type="primary" @click="sendEod">
                    Yes
                  </a-button>
                  <a-button @click="eodModalVisible2 = false">
                    No
                  </a-button>
                </div>
            </template>
        </a-modal>

      <a-drawer v-if="drawerVisible" title="" :width="380" placement="right" @close="onClose" :visible="drawerVisible">
        <br>
        <!-- SIGN OFF -->
        <div v-if="formType == 'sign_off' || formType == 'declare'">
          <h6 v-if="formType == 'sign_off'" class="heading-small text-muted">FORCE SIGN-OFF</h6>
          <h6 v-else class="heading-small text-muted">FORCE DECLARATION</h6>
          <base-input label="Business Date">
            <a-date-picker v-model="businessDate" format="YYYY-MM-DD" placeholder="Business Date" style="width:100%"/>
          </base-input>
          <base-input label="Time">
            <a-time-picker v-model="inputTime" format="hh:mm" style="width: 100%" />
          </base-input>
          <div class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
              <button class="btn btn-primary" @click.prevent="onClose">Cancel</button>
              <button v-if="formType == 'sign_off'" class="btn btn-success" @click="forceSignOff">Proceed</button>
              <button v-else class="btn btn-success" @click="forceDeclare">Proceed</button>
          </div>
        </div>
        <!-- AUDIT -->
        <div v-if="formType == 'audit'">
          <h6 class="heading-small text-muted">FOR DECLARATION (AUDIT)</h6>
          <div v-if="declarationMode == 2">
            <base-input v-model="actualCashAmount" label="Actual Cash Amount" type="number"></base-input>
          </div>
          <div v-if="declarationMode == 1">
            <table v-if=' !_.isEmpty(moneyBreadown)' class="table table-sm" style="overflow: hidden; table-layout: fixed; word-wrap: break-word;">
             <tbody>
               <tr>
                 <th>Denomination</th>
                 <td align="right">Quantity</td>
               </tr>
               <tr v-for="(denomination, index) in moneyBreadown" :key="index">
                <template>
                  <td>{{denomination}}</td>
                  <td align="right"> <input type="text" class="form-control" size="sm" v-model="auditBreakdown[denomination]"></td>
                </template>
               </tr>
               <tr>
                 <td>TOTAL CASH</td>
                 <td>{{auditBreakdownTotal.toFixed(2)}}</td>
               </tr>
             </tbody>
           </table>
           <br/><br/><br/>
          </div>
          <div class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
              <button class="btn btn-primary" @click.prevent="onClose">Cancel</button>
              <button class="btn btn-success" @click="modalVisible = true">Proceed</button>
          </div>
        </div>

        <!-- BREAKDOWN -->
        <div v-if="formType == 'show_breakdown'">
          <div v-if="declarationMode == 1">
            <h6 class="heading-small text-muted">DECLARATION BREAKDOWN</h6>
            <br/>

             <h6 class="heading-small text-muted">CASH</h6>
             <table v-if=' !_.isEmpty(breakdown)' class="table table-sm" style="overflow: hidden; table-layout: fixed; word-wrap: break-word;">
             <tbody>
               <tr>
                 <th>Denomination</th>
                 <th>Qty</th>
               </tr>
               <tr v-for="(item, key, index) in breakdown" :key="index">
                <template v-if= "!_.isNaN(parseFloat(key))">
                  <td>{{key}}</td>
                  <td>{{item}}</td>
                </template>
               </tr>
             </tbody>
             </table>

            <br/> <br/>
            <h6 class="heading-small text-muted">NON-CASH</h6>
             <table v-if=' !_.isEmpty(breakdown)' class="table table-sm" style="overflow: hidden; table-layout: fixed; word-wrap: break-word;">
             <tbody>
               <tr>
                 <th>Non-Cash</th>
                 <th>Amount</th>
               </tr>
               <tr v-for="(item, key, index) in breakdown" :key="index">
                <template v-if= "_.isNaN(parseFloat(key))">
                  <td>{{key}}</td>
                  <td>{{item}}</td>
                </template>
               </tr>
             </tbody>
             </table>

             <div v-else>
                <a-empty class='mt-5' :image-style="{height: '50px',}" >
                    <span slot="description"> No breakdown specified for the selected declaration. </span>
                </a-empty>
             </div>
           </div>

          <br/> <br/>

           <div v-if="!_.isEmpty(audRemarks)">
             <h6 class="heading-small text-muted">REMARKS</h6>
             <div class="pre-formatted">
               {{audRemarks}}
             </div>
           </div>
          <div class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
              <button class="btn btn-primary" @click.prevent="onClose">Cancel</button>
          </div>
        </div>

        <!-- VALIDATE -->
        <div v-if="formType == 'validate'">
          <h6 class="heading-small text-muted">DETAILS</h6>

          <a-statistic title="Expected vs Actual" :precision="2" :value="selectedRows[0].actual_cash_amount">
            <template #prefix>
              <span> {{selectedRows[0].expected_cash_amount}} vs.</span>
            </template>
            <template #suffix>
                <h3 v-if="parseFloat(selectedRows[0].actual_cash_amount) - parseFloat(selectedRows[0].expected_cash_amount) > 0"><span class="fa fa-arrow-up text-green"/> Over: {{ ( parseFloat(selectedRows[0].actual_cash_amount) - parseFloat(selectedRows[0].expected_cash_amount) ).toFixed(2)}} </h3>
                <h3 v-if="parseFloat(selectedRows[0].actual_cash_amount) - parseFloat(selectedRows[0].expected_cash_amount) < 0"><span class="fa fa-arrow-down text-red"/> Short: {{ ( parseFloat(selectedRows[0].actual_cash_amount) - parseFloat(selectedRows[0].expected_cash_amount) ).toFixed(2)}} </h3>
            </template>
          </a-statistic>
          <br/>

          <div v-if ="!_.isEmpty(validateData)" >
          <h6 class="heading-small text-muted">TRANSACTION SUMMARY</h6>
          <table v-if=' !_.isEmpty(validateData)' class="table table-sm" style="overflow: hidden; table-layout: fixed; word-wrap: break-word;">
            <tbody>
              <tr>
                <th>Transaction Reference</th>
                <td align="right">Amount</td>
              </tr>
              <tr v-for="(item, key, index) in validateData.sales" :key="index">
                <td>TOTAL SALES</td>
                <td align="right">{{item.amount_gross}}</td>
              </tr>
              <tr v-for="(item, key, index) in validateData.cash_in" :key="index">
                <td>DEP-{{item.id}}</td>
                <td align="right">{{item.amount}}</td>
              </tr>
              <tr v-for="(item, key, index) in validateData.cash_out" :key="index">
                <td>WIT-{{item.id}}</td>
                <td align="right">({{item.amount}})</td>
              </tr>
              <tr>
                <td>TOTAL: </td>
                <td align="right"><h5>{{validateData.total}}</h5></td>
              </tr>
            </tbody>
          </table>
          </div>

          <div v-if="declarationMode == 1">
            <div v-if=' !_.isEmpty(breakdown)'>
            <h6 class="heading-small text-muted">DECLARATION BREAKDOWN</h6>
            <h6 class="heading-small text-muted">CASH</h6>
            <table class="table table-sm" style="overflow: hidden; table-layout: fixed; word-wrap: break-word;">
              <tbody>
                <tr>
                  <th>Denomination</th>
                  <td align="right">Qty</td>
                  <td align="right">Amount</td>
                </tr>
                <tr v-for="(item, key, index) in breakdown" :key="index">
                 <template v-if= "!_.isNaN(parseFloat(key))">
                   <td>{{key}}</td>
                   <td align="right">{{item}}</td>
                    <td align="right">{{parseInt(key) * parseInt(item)}}</td>
                 </template>
                </tr>
              </tbody>
            </table>

            <br/>
            <h6 class="heading-small text-muted">NON-CASH</h6>
             <table class="table table-sm" style="overflow: hidden; table-layout: fixed; word-wrap: break-word;">
               <tbody>
                 <tr>
                   <th>Non-Cash</th>
                   <td align="right">Amount</td>
                 </tr>
                 <tr v-for="(item, key, index) in breakdown" :key="index">
                  <template v-if= "_.isNaN(parseFloat(key))">
                    <td>{{key}}</td>
                    <td align="right">{{item}}</td>
                  </template>
                 </tr>
               </tbody>
             </table>

            <table class="table table-sm" style="overflow: hidden; table-layout: fixed; word-wrap: break-word;">
              <tbody>
                <tr>
                  <td>TOTAL: </td>
                  <td align="right"><h5>{{this.selectedRows[0].actual_cash_amount}}</h5></td>
                </tr>
                <tr>
                  <td>CASH FOR DEPOSIT: </td>
                  <td align="right"><h5>{{this.selectedRows[0].actual_cash_amount - (parseFloat(validateData.initial_fund) + parseFloat(newDeclarationAmountNonCash)) }}</h5></td>
                </tr>
              </tbody>
           </table>
            </div>

           <div v-else-if="_.isEmpty(breakdown)">
              <a-empty class='mt-5' :image-style="{height: '50px',}" >
                  <span slot="description"> No breakdown specified for the selected declaration. </span>
              </a-empty>
           </div>
          </div>

          <br/>
           <div v-if="!_.isEmpty(audRemarks)">
             <h6 class="heading-small text-muted">REMARKS</h6>
              <div class="pre-formatted">
               {{audRemarks}}
             </div>
           </div>


           <br/><br/><br/>

          <div class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
            <a-popconfirm title='Are you sure you want to override the declaration values?' class="btn btn-sm btn-danger" @confirm="() => override()">
                Override
            </a-popconfirm>
            <button class="btn btn-sm btn-primary" @click.prevent="showSessionDetails">View Details</button>
          </div>

        </div>

        <!-- OVERRIDE -->
        <div v-if="formType == 'override'">
          <h6 class="heading-small text-muted">OVERRIDE DECLARATION</h6>
            <div v-if="declarationMode == 2">
              <base-input v-model="overrideAmount" label="Override Amount" type="number"></base-input>
            </div>

            <div v-if="declarationMode == 1">
              <table v-if=' !_.isEmpty(moneyBreadown)' class="table table-sm" style="overflow: hidden; table-layout: fixed; word-wrap: break-word;">
                 <tbody>
                   <tr>
                     <th>Denomination</th>
                     <td align="right">Quantity</td>
                   </tr>
                   <tr v-for="(denomination, index) in moneyBreadown" :key="index">
                    <template>
                      <td>{{denomination}}</td>
                      <td align="right"> <input type="text" class="form-control" size="sm" v-model="breakdown[denomination]"></td>
                    </template>
                   </tr>
                 </tbody>
               </table>

              <table v-if=' !_.isEmpty(nonCashDenomination)' class="table table-sm" style="overflow: hidden; table-layout: fixed; word-wrap: break-word;">
               <tbody>
                 <tr>
                   <th>Non-Cash</th>
                   <td align="right">Amount</td>
                 </tr>
                 <tr v-for="(denomination, index) in nonCashDenomination" :key="index">
                  <template>
                    <td>{{denomination}}</td>
                    <td align="right"> <input type="text" class="form-control" size="sm" v-model="breakdown[denomination]"></td>
                  </template>
                 </tr>
               </tbody>
              </table>
            </div>


          <br/><br/>
          <div class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
            <button v-if="accessRights.includes('W')" class="btn btn-danger" @click="modalVisible2 = true">Confirm</button>
            <button class="btn btn-primary" @click.prevent="onClose">Cancel</button>
          </div>

        </div>
      </a-drawer>
      <div class="row align-items-center">
        <div class="col-md-3">
          <base-input label="Business Date">
            <a-date-picker v-model="filterDate" format="YYYY-MM-DD" placeholder="Business Date" style="width:100%"/>
          </base-input>
        </div>
        <div class="col-md-6">
          <base-input label="Status">
            <a-select  v-model="filterStatus" placeholder="Status" optionFilterProp="children" style="width: 100%">
              <a-select-option :value="0">All</a-select-option>
              <a-select-option :value="1"><a-badge status="error"/> Pending</a-select-option>
              <a-select-option :value="2"><a-badge status="warning"/> For Declaration (Audit)</a-select-option>
              <a-select-option :value="3"><a-badge status="success"/> Declared</a-select-option>
            </a-select>
          </base-input>
        </div>
        <div v-if="eodDate" class="col-md-3 eod-cont">
          <base-input label="EOD Date">
            <a-input
              style="width: 100%"
              placeholder="EOD Date"
              v-model="eodDate"
              readOnly/>
          </base-input>
        </div>
      </div>
    </div>
  <div class="d-none d-sm-block">
    <a-table :columns="optionColumns" :dataSource="posSessions" :row-selection="{type: 'radio', onChange: onChange}" bordered style="height: 100vh;" :key="tableKey">
      <span slot="session_id" slot-scope="record, text">
        <a-badge v-if="text.is_declared == 1" status="success" />
        <a-badge v-else-if="text.declare_date_formatted != '' && text.is_declared != 1" status="warning" />
        <a-badge v-else status="error" />
        {{text.session_id}}
      </span>
      <small slot="expandedRowRender" slot-scope="record" style="margin: 0">
        <div class="row">
          <div v-if="record.trans_count != null" class="col-md-3">
            <a-statistic title="Transactions" :value="record.trans_count" style="margin-right: 50px"/>
            Transaction No : {{record.start_trans_id}} - {{record.end_trans_id}}
          </div>
          <div v-else class="col-md-3">
            <a-statistic title="Transactions" :value="0" style="margin-right: 50px"/>
          </div>

          <div class="col-md-4">
            <a-statistic title="Expected vs Actual" :precision="2" :value="record.actual_cash_amount" v-if="record.is_declared == true" style="margin-right: 130px">
              <template #prefix>
                <span v-if="record.excludeInitialCashFloat == true || record.float == null"> {{ parseFloat(record.expected_cash_amount).toFixed(2) }} vs.</span>
                <span v-else> {{ (parseFloat(record.expected_cash_amount) + parseFloat(record.float)).toFixed(2) }} vs.</span>
              </template>
              <template #suffix>
                  <h3 v-if="parseFloat(record.actual_cash_amount) - parseFloat(record.expected_cash_amount) > 0"><span class="fa fa-arrow-up text-green"/> Over: {{ (parseFloat(record.actual_cash_amount) - parseFloat(record.expected_cash_amount) ).toFixed(2) }} </h3>
                  <h3 v-if="parseFloat(record.actual_cash_amount) - parseFloat(record.expected_cash_amount) < 0"><span class="fa fa-arrow-down text-red"/> Short: {{ (parseFloat(record.actual_cash_amount) - parseFloat(record.expected_cash_amount) ).toFixed(2)}} </h3>
              </template>
            </a-statistic>
            <a-statistic title="Expected vs Actual" :precision="2" :value="0.00" class="demo-class" v-else>
              <template #suffix>
                <span> vs. XXX.XX </span>
              </template>
            </a-statistic>
          </div>

          <div class="col-md-2">
            <a-statistic :precision="2" v-if= "_.isEmpty(record.sales_amount)" title="Sales" :value="0" class="demo-class">
            </a-statistic>
             <a-statistic :precision="2" v-else title="Sales" :value="record.sales_amount" class="demo-class">
            </a-statistic>
          </div>
          <div class="col-md-3">
            <a-statistic :precision="2" v-if= "_.isEmpty(record.returns_amount)" title="Returns" :value="0" class="demo-class">
            </a-statistic>
            <a-statistic :precision="2" v-else title="Returns" :value="record.returns_amount" class="demo-class">
            </a-statistic>
          </div>

        </div>

        <hr class="my-3">

        <div class="row">
          <div v-if="record.activity_count != null" class="col-md-3">
            <a-statistic title="Activities" :value="record.activity_count" style="margin-right: 50px"/>
            Activity No : {{record.start_activity_id}} - {{record.end_activity_id}}
          </div>
          <div v-else class="col-md-3">
            <a-statistic title="Activities" :value="0" style="margin-right: 50px"/>
          </div>
          <div class="col-md-4">
            <a-statistic :precision="2" v-if= "_.isEmpty(record.withdraw_amount)" title="Pickup" :value="0" style="margin-right: 50px"/>
            <a-statistic :precision="2" v-else title="Pickup" :value="record.withdraw_amount" style="margin-right: 50px"/>
          </div>
          <div class="col-md-2">
            <a-statistic :precision="2" v-if= "_.isEmpty(record.float)" title="Float" :value="0" style="margin-right: 50px"/>
            <a-statistic :precision="2" v-else-if= "record.excludeInitialCashFloat == true" title="Float" :value="0" style="margin-right: 50px"/>
            <a-statistic :precision="2" v-else title="Float" :value="record.float" style="margin-right: 50px"/>
          </div>
          <div class="col-md-3">
            <a-statistic :precision="2" v-if= "_.isEmpty(record.deposit_amount)" title="Deposit" :value="0" style="margin-right: 50px"/>
            <a-statistic :precision="2" v-else title="Deposit" :value="record.deposit_amount" style="margin-right: 50px"/>
          </div>
        </div>
      </small>
    </a-table>
  </div>

  <div class="d-block d-sm-none">
  <a-table :columns="optionColumns2" :dataSource="posSessions" :row-selection="{type: 'radio', onChange: onChange}" bordered style="height: 100vh;" :key="tableKey">

      <span slot="user_name" slot-scope="record, text">
        {{text.user_name}}<br/>
        <small>Terminal: {{text.terminal_name}}<br/>
        <a-badge v-if="text.is_declared == 1" status="success" />
        <a-badge v-else-if="text.declare_date_formatted != '' && text.is_declared != 1" status="warning" />
        <a-badge v-else status="error" />
        Sesion ID: {{text.session_id}} </small>
      </span>

      <small slot="expandedRowRender" slot-scope="record" style="margin: 0">
        <div class="row">
          <div v-if="record.trans_count != null" class="col-md-3">
            <a-statistic title="Transactions" :value="record.trans_count" style="margin-right: 50px"/>
            Transaction No : {{record.start_trans_id}} - {{record.end_trans_id}}
          </div>
          <div v-else class="col-md-3">
            <a-statistic title="Transactions" :value="0" style="margin-right: 50px"/>
          </div>

          <div class="col-md-4">
            <a-statistic title="Expected vs Actual" :precision="2" :value="record.actual_cash_amount" v-if="record.is_declared == true" style="margin-right: 130px">
              <template #prefix>
                <span> {{record.expected_cash_amount}} vs.</span>
              </template>
              <template #suffix>
                  <h3 v-if="parseFloat(record.actual_cash_amount) - parseFloat(record.expected_cash_amount) > 0"><span class="fa fa-arrow-up text-green"/> Over: {{ ( parseFloat(record.actual_cash_amount) - parseFloat(record.expected_cash_amount) ).toFixed(2)}} </h3>
                  <h3 v-if="parseFloat(record.actual_cash_amount) - parseFloat(record.expected_cash_amount) < 0"><span class="fa fa-arrow-down text-red"/> Short: {{ ( parseFloat(record.actual_cash_amount) - parseFloat(record.expected_cash_amount) ).toFixed(2)}} </h3>
              </template>
            </a-statistic>
            <a-statistic title="Expected vs Actual" :precision="2" :value="0.00" class="demo-class" v-else>
              <template #suffix>
                <span> vs. XXX.XX </span>
              </template>
            </a-statistic>
          </div>

          <div class="col-md-2">
            <a-statistic :precision="2" v-if= "_.isEmpty(record.sales_amount)" title="Sales" :value="0" class="demo-class">
            </a-statistic>
             <a-statistic :precision="2" v-else title="Sales" :value="record.sales_amount" class="demo-class">
            </a-statistic>
          </div>
          <div class="col-md-3">
            <a-statistic :precision="2" v-if= "_.isEmpty(record.returns_amount)" title="Returns" :value="0" class="demo-class">
            </a-statistic>
            <a-statistic :precision="2" v-else title="Returns" :value="record.returns_amount" class="demo-class">
            </a-statistic>
          </div>

        </div>

        <hr class="my-3">

        <div class="row">
          <div v-if="record.activity_count != null" class="col-md-3">
            <a-statistic title="Activities" :value="record.activity_count" style="margin-right: 50px"/>
            Activity No : {{record.start_activity_id}} - {{record.end_activity_id}}
          </div>
          <div v-else class="col-md-3">
            <a-statistic title="Activities" :value="0" style="margin-right: 50px"/>
          </div>
          <div class="col-md-4">
            <a-statistic :precision="2" v-if= "_.isEmpty(record.withdraw_amount)" title="Pickup" :value="0" style="margin-right: 50px"/>
            <a-statistic :precision="2" v-else title="Pickup" :value="record.withdraw_amount" style="margin-right: 50px"/>
          </div>
          <div class="col-md-2">
            <a-statistic :precision="2" v-if= "_.isEmpty(record.float)" title="Float" :value="0" style="margin-right: 50px"/>
            <a-statistic :precision="2" v-else-if= "record.excludeInitialCashFloat == true" title="Float" :value="0" style="margin-right: 50px"/>
            <a-statistic :precision="2" v-else title="Float" :value="record.float" style="margin-right: 50px"/>
          </div>
          <div class="col-md-3">
            <a-statistic :precision="2" v-if= "_.isEmpty(record.deposit_amount)" title="Deposit" :value="0" style="margin-right: 50px"/>
            <a-statistic :precision="2" v-else title="Deposit" :value="record.deposit_amount" style="margin-right: 50px"/>
          </div>
        </div>
        <!-- <div v-if="record.activity_count != null">
          Activity ({{record.activity_count}}) : <br>
          Activity # {{record.start_activity_id}} - Activity # {{record.end_activity_id}}
        </div> -->
      </small>
    </a-table>
  </div>

  </div>
  </a-spin>
</template>

<script>

  import axios from "axios";
  import {
    mapState,
    mapActions
  } from 'vuex'

  import secureStorage from '../../controllers/secureStorage';
  import HTTPRequest from '../../controllers/httpRequest.js';
  import moment from 'moment';
  import jsPDF from 'jspdf';
  import 'jspdf-autotable';

  var component_x;

  export default {
    name: 'profiles-table',
    props: {
      type: {
        type: String
      },
      title: String
    },
    computed: {
      ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'profileId', 'parameters', 'serverType', 'publicUrl']),
    },
    data() {
      return {
        auditBreakdownTotal: 0,
        auditBreakdown: {},
        declarationMode: 1,
        withEod: -1,
        error_msg: '',
        totalMissing: 0,
        eodMessage: "",
        eodModalVisible: false,
        eodModalVisible2: false,
        proceedEod: false,
        siteName: secureStorage.getItem("defaultSiteName"),
        siteId: secureStorage.getItem("defaultSiteId"),
        userId: secureStorage.getItem("userId"),
        eodDetails: [],
        showEOD: false,
        declaredCount: -1,
        sessionDetailsVisible: false,
        fetching: false,
        tableKey: 0,
        actionKey: 0,
        filterDate: moment(),
        eodDate: null,
        modalVisible: false,
        modalVisible2: false,
        actualCashAmount: 0,
        businessDate: moment(),
        inputTime: moment(moment(), 'h A'),
        selectedIndex: 0,
        formType: null,
        drawerVisible: false,
        filterStatus: 0,
        profileAction: "",
        errorMessage: null,
        successMessage: null,
        apiURL: "",
        posSessions: [],
        selectedRowKeys: null,
        selectedRows: [],
        breakdown: {},
        audRemarks: null,
        validateData: {},
        accessRights: [],
        moneyBreadown: ["1000.00", "500.00", "200.00", "100.00", "50.00", "20.00", "10.00", "5.00", "1.00", "0.50", "0.25", "0.10", "0.05", "0.01"],
        nonCashDenomination: [],
        overrideAmount: 0,
        newDeclarationAmount: 0,
        newDeclarationAmountCash: 0,
        newDeclarationAmountNonCash: 0,
        isHalfOfALetter:false,
        optionColumns2: [
          {
            title: 'Session',
            dataIndex: 'user_name',
            scopedSlots: { customRender: 'user_name' },
          }
        ],
        spinning: false,
        optionColumns: [
          {
            title: 'Cashier',
            dataIndex: 'user_name',
          },
          {
            title: 'Terminal',
            dataIndex: 'terminal_name',
          },
          {
            title: 'Session ID',
            dataIndex: 'session_id',
            scopedSlots: { customRender: 'session_id' },
          },
          {
            title: 'Sign On Date',
            dataIndex: 'sign_on_date_formatted',
            width: "15%"
          },
          {
            title: 'Sign Off Date',
            dataIndex: 'sign_off_date_formatted',
            width: "15%"
          },
          {
            title: 'POS Declare Date',
            dataIndex: 'declare_date_formatted',
            width: "15%"
          },

      ],

      eodColumns: [
          {
            title: 'POS Terminal',
            dataIndex: 'terminal_label',
          },
          {
            title: 'First Trx',
            dataIndex: 'first_trans',
          },
          {
            title: 'Last Trx',
            dataIndex: 'end_trans',
          },
          {
            title: 'Expected #',
            dataIndex: 'trans_count',
          },
          {
            title: 'Actual #',
            dataIndex: 'actual_count',
          },
          {
            title: 'Missing #',
            dataIndex: 'missing',
            scopedSlots: { customRender: 'missing' },
          }
      ],
      }
    },
    methods: {
      moment,
      async getSessions(){
        var siteId = secureStorage.getItem("defaultSiteId")
        var posSessions = await HTTPRequest.getRequest(this.endPoint + 'pos_sessions?site_id=' + siteId + '&business_date=' + this.filterDate.format('YYYY-MM-DD') + '&status=' + this.filterStatus , null)
        this.posSessions = []

        //  Add API For checking no of undeclared sessions
        var posSessions2 = await HTTPRequest.getRequest(this.endPoint + 'pos_sessions?site_id=' + siteId + '&business_date=' + this.filterDate.format('YYYY-MM-DD') + '&is_declared=1' , null)
        
        var supervisorSessions = 0
        for (var session of posSessions.data) {
          var x = 0
          
          if(session.is_declared == 0){
            var memberships = await HTTPRequest.getRequest(this.endPoint + 'user_memberships?user_id=' + session.user_id, null)
            if(memberships.data.length == 1){
              var supervisorId = await HTTPRequest.getRequest(this.endPoint+ 'user_groups?status=A&name=supervisor', null)
              supervisorId = supervisorId.data[0].id
              if((supervisorId != undefined) && memberships.data[0].user_group_id == supervisorId){
                supervisorSessions += 1
                console.log(supervisorSessions)
              }
            }
          }

          let excludeInitialCashFloatSetting = session.terminal_settings.filter((a) => { if (a.code == 'excludeInitialCashFloat') { return a } });
          let excludeManualReceiptSetting = session.terminal_settings.filter((a) => { if (a.code == 'excludeManualReceipt') { return a } });
          if (excludeInitialCashFloatSetting[0] != undefined) {
            this.excludeInitialCashFloat = excludeInitialCashFloatSetting[0]["value"];

            if (this.excludeInitialCashFloat == null){
             this.excludeInitialCashFloat = false
            }
          } else {
            this.excludeInitialCashFloat = false
          }

          if (excludeManualReceiptSetting[0] != undefined) {
            this.excludeManualReceipt = excludeManualReceiptSetting[0]["value"];

            if (this.excludeManualReceipt == null){
             this.excludeManualReceipt = false
            }
          } else {
            this.excludeManualReceipt = false
          }

          // add excludeInitialCashFloat settings into pos sessions data
          session.excludeInitialCashFloat = this.excludeInitialCashFloat
          session.excludeManualReceipt = this.excludeManualReceipt

          if (this.excludeManualReceipt == true){
            session.expected_cash_amount = parseFloat(session.expected_cash_amount) - parseFloat(session.manual_trans_cash_amount)
          }
          
          this.posSessions.push(session)
          x++
        }

        console.log("sup", supervisorSessions)
        console.log("cashier", posSessions2.data.length)

        this.declaredCount = posSessions2.data.length + supervisorSessions

        console.log("-----------------");
        console.log(this.declaredCount);

        await this.checkEndOfDay();
     },
      async forceSignOff(){
        var posSessionPayload = { pos_session: { sign_off_date: this.businessDate.format('YYYY-MM-DD') + " " + this.inputTime.format('HH:mm'), is_forced_signoff: true}}
        var updateSession = await HTTPRequest.putRequest(this.endPoint + 'pos_sessions/' + this.selectedRows[this.selectedIndex].id , null, posSessionPayload)
        // ADD CREATION OF POS ACTIVITY > SOF
        if(updateSession.error == undefined){
          await this.getSessions()
          this.onClose();
          this.$message['success'](
            "Force Logout action is successful."
          );
          this.selectedRows = [];
        }
      },
      async forceDeclare() {
        // Check if with zread
        var getZreadCount = await HTTPRequest.getRequest(this.endPoint + `z_readings/get_zread_count?business_date=${this.businessDate.format('YYYY-MM-DD') + " " + this.inputTime.format('HH:mm')}` + "&terminal_id=" + this.selectedRows[this.selectedIndex].terminal_id , null)
        var is_with_zread = false

        if (getZreadCount > 0) {
          is_with_zread = true
        } else {
          is_with_zread = false
        }
        
        var posSessionPayload = { pos_session: { declare_date: this.businessDate.format('YYYY-MM-DD') + " " + this.inputTime.format('HH:mm'), is_forced_declared: true, is_with_zread: is_with_zread}}
        var updateSession = await HTTPRequest.putRequest(this.endPoint + 'pos_sessions/' + this.selectedRows[this.selectedIndex].id , null, posSessionPayload)
        // ADD CREATION OF POS ACTIVITY > DEC
        if(updateSession.error == undefined){
          await this.getSessions()
          this.onClose();
          this.$message['success'](
            "Force Declare action is successful."
          );
          this.selectedRows = [];
        }
      },
      async audit(){
        if(this.declarationMode == 2){
          var posSessionPayload = { pos_session: { actual_cash_amount: this.actualCashAmount, is_declared: 1}}
        }else{
          var posSessionPayload = { pos_session: { actual_cash_amount: this.auditBreakdownTotal, is_declared: 1, data: JSON.stringify(this.auditBreakdown)}}
        }

        var updateSession = await HTTPRequest.putRequest(this.endPoint + 'pos_sessions/' + this.selectedRows[this.selectedIndex].id , null, posSessionPayload)
        if(updateSession.error == undefined){
          await this.getSessions()
          this.auditBreakdownTotal = 0;
          this.auditBreakdown = {}
          this.modalVisible = false
          this.onClose();
          this.$message['success'](
            "Declaration (Audit) action is successful."
          );
          this.selectedRows = [];
        }
      },
      async showDrawer(type){
        this.formType = type
        this.drawerVisible = true

        if(type =="validate" || type == "override"){
          this.overrideAmount = 0
          let selectedSession = this.selectedRows[0]
          var siteId = selectedSession.site_id
          var userId = selectedSession.user_id
          var terminalId = selectedSession.terminal_id
          var sessionId = selectedSession.session_id
          let sessionParams = {site_id: siteId, user_id: userId, session_id: sessionId, terminal_id: terminalId, business_date: this.filterDate.format('YYYY-MM-DD'), trans_code: "AUD"}
          var declaration = await HTTPRequest.getRequest(this.endPoint + 'pos_activities' , sessionParams)

          if(declaration.length > 0){
            console.log("~~~WILL FOLLOW THIS")
            this.breakdown = declaration[0].breakdown;
            this.nonCashDenomination = []
            if(!_.isEmpty(this.breakdown)){
              Object.keys(component_x.breakdown).forEach(function (key) {
                if( _.isNaN(parseFloat(key)) ){
                  component_x.nonCashDenomination.push(key)
                }
              })
            }else{
              this.breakdown = {}
            }

            this.audRemarks = declaration[0].remarks;
            // console.log(declaration[0].remarks.split("↵"))
            // console.log(this.audRemarks);
            // console.log(this.audRemarks.split("↵"))
          } else{
            console.log("DATA--")
            console.log(JSON.parse(selectedSession.data))
            this.breakdown = JSON.parse(selectedSession.data)
          }

          // if(this.declarationMode == 2)
          //     this.overrideAmount = parseFloat(selectedSession.actual_cash_amount)

          console.log("VALUE--")
          console.log(this.breakdown)
          var validate_data = await HTTPRequest.getRequest(this.endPoint + 'pos_sessions/' + selectedSession.id + "/validate")
          this.validateData = validate_data;
        }

        let selectedSession = this.selectedRows[0]
        var terminalId = selectedSession.terminal_id
        var getSettings = await HTTPRequest.getRequest(this.endPoint + `terminals/authenticate?terminal_id=${terminalId}`, null)
        var terminalSettings = getSettings.pos_terminal_settings
        let settings = terminalSettings.filter( (a) => { if(a.code == 'declarationMode'){return a}});
        if (settings[0].value != undefined){
          this.declarationMode = parseInt(settings[0].value)
        } else {
          // if no settings set mode to 1
          this.declarationMode = 1
        }
      },
      async getEndOfDay() {
        let siteId = secureStorage.getItem("defaultSiteId");
        let url = this.endPoint + `pos_sessions/get_eod_records?site_id=${siteId}&business_date=${this.filterDate.format('YYYY-MM-DD')}`;
        let getEOD = await HTTPRequest.getRequest(url, null);
        this.eodDetails = getEOD.eod_records
        this.proceedEod = getEOD.proceed_eod
        this.totalMissing = getEOD.missing
        this.withEod = getEOD.with_eod
        this.eodDate = getEOD.eod_date
        this.error_msg = getEOD.error
      },
      async checkEndOfDay() {
        await this.getEndOfDay();
      },
      async startEndOfDay(){
        await this.getEndOfDay();
        if(this.withEod > 0){
          this.$message['warning'](
            `There is already an existing End of Day on this business date ${this.filterDate.format('YYYY-MM-DD')}`
          );
        }else if(this.totalMissing > 0){
          this.$message['warning'](
            `There is missing ${this.totalMissing} transaction(s) the End of Day cannot proceed`
          );
        }else if(this.error_msg != ""){
          this.$message['warning'](
            `${this.error_msg}`
          );
        }else{
          this.showEOD = true
        }
      },
      async override(){
        this.showDrawer("override");
      },
      async overrideDeclaration(){
        this.fetching = true
        let selectedSession = this.selectedRows[0]
        var siteId = selectedSession.site_id
        var userId = selectedSession.user_id
        var terminalId = selectedSession.terminal_id
        var sessionId = selectedSession.session_id
        let sessionParams = {site_id: siteId, user_id: userId, session_id: sessionId, terminal_id: terminalId, business_date: this.filterDate.format('YYYY-MM-DD'), trans_code: "AUD"}
        var declaration = await HTTPRequest.getRequest(this.endPoint + 'pos_activities' , sessionParams)

        if(_.isEmpty(declaration)){
          // console.log( "EMPTY DECLARATION" )
          var updateActivity = {success: true}
        }else{
          if(this.declarationMode == 1){
            //this.newDeclarationAmount = this.newDeclarationAmountCash + this.newDeclarationAmountNonCash
            // console.log( "~~~~~!!! HERE" )
            // console.log( this.computeBreakdownCash() );
	          // console.log( this.computeBreakdownNonCash() );
            this.newDeclarationAmount = this.computeBreakdownCash() + this.computeBreakdownNonCash()
            var posActivityPayload = { pos_activity: { amount: this.newDeclarationAmount, data: JSON.stringify( {breakdown: this.breakdown } )}}
          }else{
            // console.log( this.overrideAmount );
            this.newDeclarationAmount = this.overrideAmount
            var posActivityPayload = { pos_activity: { amount: this.newDeclarationAmount, data: JSON.stringify( {breakdown: {} } )}}
            // this.breakdown = {}
          }

          var updateActivity = await HTTPRequest.putRequest(this.endPoint + 'pos_activities/' + declaration[0].id , null, posActivityPayload)
        }

        if(updateActivity.error == undefined){
          if(this.declarationMode == 1){
            this.newDeclarationAmount = this.computeBreakdownCash() + this.computeBreakdownNonCash()
            console.log("~~MUST BE HERE");
            console.log(`ACTUAL CASH AMT: ${this.newDeclarationAmount}`)
            console.log(`BREAKDOWN: ${JSON.stringify(this.breakdown)}`)
            var posSessionPayload = { pos_session: { actual_cash_amount: this.newDeclarationAmount, data: JSON.stringify(this.breakdown) } }
          }else{
            var posSessionPayload = { pos_session: { actual_cash_amount: this.overrideAmount, data: JSON.stringify({}) } }
          }


          var updateSession = await HTTPRequest.putRequest(this.endPoint + 'pos_sessions/' + this.selectedRows[this.selectedIndex].id , null, posSessionPayload)
          if(updateSession.error == undefined){
            await this.getSessions()
            this.modalVisible2 = false
            this.onClose();
            this.$message['success'](
              "Declaration Override is successful."
            );
            this.selectedRows = [];
          }
        }
        this.fetching = false
      },
      computeBreakdownCash(){
        var sum = 0;
        Object.keys(component_x.breakdown).forEach(function (key) {
          if( _.isNaN(parseFloat(key)) ){
            // console.log(`NOT COMPUTING SUM`)
          } else {
            if(parseFloat(component_x.breakdown[key]) > 0){
              var value = parseFloat(component_x.breakdown[key]) * parseFloat(key)
              // console.log(value);
            } else {
              delete component_x.breakdown[key]
            }
            sum += value
            // console.log(`SUM: ${sum}`)
          }

        })
       this.newDeclarationAmountCash = sum;
       return this.newDeclarationAmountCash;
      },
      computeAuditBreakdownCash(){
        var sum = 0;
        Object.keys(component_x.auditBreakdown).forEach(function (key) {
            console.log("----------")
            // console.log(`Key: ${key}`)
            // console.log( _.isNaN( parseFloat(component_x.auditBreakdown[key]) ))

            if( _.isNaN( parseFloat(component_x.auditBreakdown[key]) )){
              console.log("NAN")
              var value = 0;
            } else {
              if(parseFloat(component_x.auditBreakdown[key]) > 0 ){
                var value = parseFloat(component_x.auditBreakdown[key]) * parseFloat(key)
              }else {
                delete component_x.auditBreakdown[key]
                // component_x.auditBreakdown[key] = 0
              }
            }
            // console.log(`Value: ${value}`)
            sum += value
        })
        // console.log("------**----")
        // alert(sum);
        this.auditBreakdownTotal = sum;
      //  this.newDeclarationAmountCash = sum;
      //  return this.newDeclarationAmountCash;
      },
      computeBreakdownNonCash(){
        var sum = 0;
        Object.keys(component_x.breakdown).forEach(function (key) {
          if( _.isNaN(parseFloat(key)) ){
            if(parseFloat(component_x.breakdown[key]) > 0){
              var value = parseFloat(component_x.breakdown[key])
            } else {
              delete component_x.breakdown[key]
            }
            sum += value
          } else {
            // console.log(`Not computing`)
          }

        })
       this.newDeclarationAmountNonCash = sum;
       return this.newDeclarationAmountNonCash;
      },
      // getSortedHash(){
      //   var resultHash = {};
      //   var inputHash = this.breakdown;
      //   var keys = Object.keys(this.breakdown);
      //   keys.sort(function(a, b) {
      //     return inputHash[a] - inputHash[b]
      //   }).forEach(function(k) {
      //     resultHash[k] = inputHash[k];
      //   });
      //   this.breakdown = resultHash;
      //   this.modalVisible2 = true;
      // },
      onChange(selectedRowKeys, selectedRows){
        console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
        this.selectedRowKeys = selectedRowKeys;
        this.selectedRows = selectedRows.slice();
      },
      onClose(){
        this.drawerVisible = false
        this.selectedRowKeys = null;
        this.selectedRows = [];
        this.tableKey++;
        this.businessDate = moment();
        this.inputTime = moment(moment(), 'h A');
        this.actualCashAmount = 0;
        this.breakdown = {}
      },
      showSessionDetails(){
        // this.sessionDetailsVisible = true
        // let routeData = this.$router.resolve({name: 'routeName', query: {data: "someData"}});
        // window.open(routeData.href, '_blank');

        this.$router.push({
            name: 'pos_session_details',
            params: {
                selectedSession: component_x.selectedRows[0],
                cashBreakdown: component_x.validateData,
                audBreakdown: component_x.breakdown
            }
        })
        // console.log(routeData.href)
        // window.open(routeData.href, '_blank');

      },
      closeEod(){
        // this.eodModalVisible = false;
        this.showEOD = false;
      },
      onCloseEod(){
        // this.showEOD = false
        this.eodModalVisible = true
        if(this.proceedEod == true){
          this.eodMessage = "No missing transaction(s) detected however please check the EOD by cashier report first and review short/over in declaration vs expected before clicking Continue if they matched. Click cancel if not and resend transactions on the POS affected and review the POS logs if the problem persists."
        }else{
          this.eodMessage = `Missing ${this.totalMissing} transaction(s) the End of Day cannot proceed. Please resend transactions on the POS affected and review the POS logs if the problem persists.`
        }
      },
      finalizeEod(){
        this.eodModalVisible = false
        this.eodModalVisible2 = true
      },
      printEod(){
        console.log("Printing Eod");
        // alert("Will Print");
        // console.log(this.selectedRows[this.selectedIndex]);
        var session = this.selectedRows[this.selectedIndex];

        var doc = new jsPDF({ orientation: 'portrait' });
        doc.setFontSize(12);
        doc.setFontType("bold");
        doc.text(15,20,"EOD Summary")

        doc.setFontType("normal");
        doc.setFontSize(10);
        doc.text(15,30, `Terminal Name: ${session.terminal_name}`)
        doc.text(15,35, `Terminal Id: ${session.terminal_id}`)
        doc.text(15,40, `Cashier Name: ${session.user_name}`)
        doc.text(15,45, `Shift ID: ${session.session_id}`)
        doc.text(15,50, `Declaration Date & Time: ${session.declare_date_formatted}`)

        // <tr v-for="(denomination, index) in moneyBreadown" :key="index">
        //    <template>
        //      <td>{{denomination}}</td>
        //      <td align="right"> <input type="text" class="form-control" size="sm" v-model="auditBreakdown[denomination]"></td>
        //    </template>
        // </tr>

        if(this.declarationMode == 1){
          doc.text(15,60, `Breakdown: `)
          var denominationBreakdown = [];
          for(var i=0; i < this.moneyBreadown.length; i++){
            var den = parseFloat(this.moneyBreadown[i]).toFixed(2);
            var qty = parseInt(this.auditBreakdown[this.moneyBreadown[i]])
            if(_.isNaN(qty))
              qty = 0
            denominationBreakdown.push([  den,  qty, (den * qty).toFixed(2) ] )
          }

          denominationBreakdown.push([  "",  "TOTAL:", parseFloat(this.auditBreakdownTotal).toFixed(2) ] )

          var headers = [ [{content: 'Denomination', styles: {halign: 'center', valign: 'center'}},
                          {content: 'Quantity', styles: {halign: 'center', valign: 'center'}},
                          {content: 'Subtotal', styles: {halign: 'center', valign: 'center'}}]
          ]

          doc.autoTable(
                        {
                            startY: 65,
                            head: headers,
                            body: denominationBreakdown,
                            theme: 'plain',
                            tableWidth: 'wrap',
                            styles: {
                                cellPadding: 0.5, fontSize: 10,
                                lineWidth: 0.05,
                                halign: 'right'
                            },
                            headStyles: {
                                lineWidth: 0.05,
                                cellPadding: 2
                            }
                        }
                    );

          // console.log("-------------------");
          // console.log(denominationBreakdown);
          doc.text(15,190, `________________________`)
          doc.text(15,195, `Cashier's Signature`)
          doc.text(85,190, `________________________`)
          doc.text(85,195, `Received By`)

        }else{
          doc.text(15,60, `Total Declared Amount: ${parseFloat(this.actualCashAmount).toFixed(2)}`)

          doc.text(15,70, `________________________`)
          doc.text(15,75, `Cashier's Signature`)
          doc.text(85,70, `________________________`)
          doc.text(85,75, `Received By`)
        }

        this.audit();
        window.open(URL.createObjectURL(doc.output("blob")))

      },
      printEodHalfOfLetter() {
        console.log("Printing Eod half");
          var session = this.selectedRows[this.selectedIndex];
          var doc = new jsPDF({ orientation: 'portrait' });
          doc.setFontSize(12);
          doc.setFontType("bold");
          doc.text(15, 20, "EOD Summary");

          doc.setFontType("normal");
          doc.setFontSize(9);
          doc.text(15, 30, `Terminal Name: ${session.terminal_name}`);
          doc.text(110, 30, `Cashier Name: ${session.user_name}`);
          doc.text(15, 35, `Terminal Id: ${session.terminal_id}`);
          doc.text(110, 35, `Shift ID: ${session.session_id}`);
          doc.text(15, 40, `Declaration Date & Time: ${session.declare_date_formatted}`);

          if (this.declarationMode == 1) {
              doc.text(15, 45, `Breakdown: `);
              var denominationBreakdown = [];
              for (var i = 0; i < this.moneyBreadown.length; i++) {
                  var den = parseFloat(this.moneyBreadown[i]).toFixed(2);
                  var qty = parseInt(this.auditBreakdown[this.moneyBreadown[i]]);
                  if (_.isNaN(qty))
                      qty = 0;
                  denominationBreakdown.push([den, qty, (den * qty).toFixed(2)]);
              }

              denominationBreakdown.push(["", "TOTAL:", parseFloat(this.auditBreakdownTotal).toFixed(2)]);

              var headers = [
                  [
                      { content: 'Denomination', styles: { halign: 'center', valign: 'middle' } },
                      { content: 'Quantity', styles: { halign: 'center', valign: 'middle' } },
                      { content: 'Subtotal', styles: { halign: 'center', valign: 'middle' } }
                  ]
              ];

              // Fine-tune the startY value to adjust the spacing
              doc.autoTable(
                  {
                      startY: 48, // Adjust this value to fine-tune the spacing
                      head: headers,
                      body: denominationBreakdown,
                      theme: 'plain',
                      tableWidth: 'wrap',
                      styles: {
                          cellPadding: 0.5,
                          fontSize: 9,
                          lineWidth: 0.05,
                          halign: 'right'
                      },
                      headStyles: {
                          lineWidth: 0.05,
                          cellPadding: 2
                      }
                  }
              );

              doc.text(15, doc.autoTable.previous.finalY + 10, `________________________`);
              doc.text(15, doc.autoTable.previous.finalY + 15, `Cashier's Signature`);
              doc.text(110, doc.autoTable.previous.finalY + 10, `________________________`);
              doc.text(110, doc.autoTable.previous.finalY + 15, `Received By`);

          } else {
              doc.text(15, 50, `Total Declared Amount: ${parseFloat(this.actualCashAmount).toFixed(2)}`);

              doc.text(15, doc.autoTable.previous.finalY + 10, `________________________`);
              doc.text(15, doc.autoTable.previous.finalY + 15, `Cashier's Signature`);
              doc.text(85, doc.autoTable.previous.finalY + 10, `________________________`);
              doc.text(85, doc.autoTable.previous.finalY + 15, `Received By`);
          }

          this.audit();
          window.open(URL.createObjectURL(doc.output("blob")));
      },
      async sendEod(){
        this.spinning = true
        this.eodModalVisible2 = false
        this.showEOD = false
        // send pos activities
        let posActivityParams = {user_id: this.userId, site_id: this.siteId, terminal_id: 0, trans_code: "EOD", status: "A", session_id: -1, business_date: this.filterDate.format('YYYY-MM-DD'), date: moment()}
        let response = await HTTPRequest.postRequest(this.endPoint + 'pos_activities/' , null, posActivityParams)

        if(response.error == undefined){
          if (response.formatted_date) this.eodDate = moment(response.formatted_date).format("D MMM YY | HH:mm");
          this.$message['success'](
            `The End of Day process has been successfully performed on this business date ${this.filterDate.format('YYYY-MM-DD')}`
          );
        }else{
          this.$message['error'](
            `The End of Day process failed on this business date ${this.filterDate.format('YYYY-MM-DD')}: (${response.error})`
          );
        }
        this.spinning = false
      }
    },
    watch:{
      filterDate: async function(){
        this.eodDate = null;
        await this.getSessions();
      },
      filterStatus: async function(){
        await this.getSessions();
      },
      auditBreakdown: {
        handler: function() {
          this.computeAuditBreakdownCash();
        },
        deep: true
      }
      // auditBreakdown: function(){
      //   // console.log("Change detected")
      //   this.computeAuditBreakdownCash();
      // }
    },
    mounted: async function () {
      component_x = this;
      this.apiURL = this.currentApiURL;
      this.accessRights = this.$attrs.accessRights;
      await this.getSessions()
      // var posSessions = await HTTPRequest.getRequest(this.endPoint + 'pos_sessions/' , null)
      // this.posSessions = posSessions.data
    }
  }
</script>

<style scoped>
.pre-formatted {
  white-space: pre;
}
</style>
